/**
 * Main entry point for the extension.
 */
define('AwaLabs.ContactUsModule', [
    'ContactUsModule.View',
    'SC.Configuration',
    'ContactUs.Model'
], function ContactUsModule(
    ContactUsView,
    Configuration,
    Model
) {
    'use strict';

    return {
        mountToApp: function mountToApp(container) {
            // instantiate and initialize the router
            // return new Router(container);

            // use the pageTypeComponent
            var pageTypeComponent = container.getComponent('PageType');
            var pages = Configuration.get('ContactUsModule.pages');
            var routes = _.pluck(pages, 'url');

            if(pages) {
                var pageTypePlucked = {
                    name: 'pagetype_contactus',
                    routes: routes,
                    view: ContactUsView,
                    options: {
                        model: new Model()
                    }
                };
    
                pageTypeComponent.registerPageType(pageTypePlucked);
            }
        }
    };
});
